export default {
  title: "Feriado de 03 de abril (Sexta-feira da Paixão) - mudanças no itinerário",
  resume: "Confira como será o funcionamento das linhas de ônibus no feriado de 03 de abril.",
  img: "/news/marcopolo-44117.png",
  publishDate: "2026-03-27T00:00:00.000-03:00",
  content: [
    "No feriado de Sexta-feira da Paixão, celebrado em 03 de abril, as linhas de ônibus municipais e metropolitanas operarão com o quadro de horários de domingos e feriados.",
    "Na quinta-feira, 02 de abril, TODAS as linhas municipais e metropolitanas irão operar com o quadro de horários de dia útil atípico, com redução nas partidas.",
    "Recomendamos aos passageiros que fiquem atentos aos horários, pois a oferta de viagens será reduzida. Além disso, não há previsão de mudanças nos itinerários passando pelo Centro Histórico, a não ser que haja procissões ou eventos religiosos informados previamente pelas paróquias.",
    "<>Para planejar sua viagem, <Link to={\"/lines\"}>consulte a página de linhas</Link> e veja os horários de partida para domingos e feriados.</>"
  ],
};
